function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import App from 'modules/App';
import MobileCountryCodeFormPartial from './MobileCountryCodeFormPartial';
var _React_PureComponent;
class CountryCodeFormPartial extends (_React_PureComponent = React.PureComponent) {
    get countryOptions() {
        return this.props.countries.map((country)=>({
                value: country.alpha2Code,
                label: get(this.props.localizationResources, [
                    country.nameKey,
                    'value'
                ]) || country.englishName
            })).sort((a, b)=>a.label.localeCompare(b.label));
    }
    render() {
        if (this.props.isMobileDisplayMode) {
            return /*#__PURE__*/ _jsx(MobileCountryCodeFormPartial, {
                formValues: this.props.formValues,
                id: "countryCode",
                optionsFrom: this.countryOptions,
                noValueMessage: App.messages.placeholders.country,
                isDisabled: this.props.isDisabled,
                onChange: this.props.onSetFormValue
            });
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "countryCode",
            labelMessage: App.messages.labels.country,
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: this.countryOptions,
                valueKey: "value",
                labelKey: "label",
                noValueMessage: App.messages.placeholders.country,
                isDisabled: this.props.isDisabled,
                onChange: this.props.onSetFormValue
            })
        });
    }
}
_define_property(CountryCodeFormPartial, "propTypes", {
    // Explicit props
    countries: PropTypes.arrayOf(App.shapes.country),
    formValues: PropTypes.object,
    isDisabled: PropTypes.bool,
    // Explicit actions
    onSetFormValue: PropTypes.func,
    // Implicit props
    localizationResources: PropTypes.object,
    isMobileDisplayMode: PropTypes.bool
});
const mapStateToProps = (state)=>({
        localizationResources: App.selectors.localizationResources(state),
        isMobileDisplayMode: App.selectors.isMobileDisplayMode(state)
    });
const ConnectedCountryCodeFormPartial = connect(mapStateToProps)(CountryCodeFormPartial);
export default ConnectedCountryCodeFormPartial;
